<div class="posting-card">
  <mat-card>
    <a [routerLink]="['/jobs', posting.jobPostingNumber]">
      <mat-card-content>
        <div class="job-title-container">
          <span class="pcl-headline-4">{{ posting.jobTitle }}</span>
        </div>
        <div>
          <span class="pcl-body pcl-dark-grey">{{ locationDisplay() }}</span>
        </div>
        <div class="flex-container wrap space-between">
          <span class="pcl-dark-grey">{{ posting.companyName }}</span>
          <span class="pcl-mid-grey">{{ posting.postingDate | date: 'longDate' : 'UTC' }}</span>
        </div>
      </mat-card-content>
    </a>
    <mat-card-actions>
      <button
        mat-icon-button
        color="primary"
        (click)="openDialog(posting)"
        [attr.aria-label]="ariaLabel()"
        data-gtm-id="share-job">
        <fa-icon [icon]="faShareFromSquare"></fa-icon>
      </button>
    </mat-card-actions>
  </mat-card>
</div>
